<template>
  <Reference
    :id="value && value.id"
    :value="value"
    :label="label || 'Контрагенти'"
    :placeholder="placeholder || 'Введіть найменування'"
    :items.sync="items"
    :total-items="totalItems"
    :hide-details="hideDetails"
    :error-messages="errorMessages"
    :multiple-select="multipleSelect"
    component-name="SalesProduct"
    :disabled="disabled"
    @input="$emit('input', $event)"
    @getItems="getItems"
  />
</template>

<script>
import * as clientsApi from "../../backend/clientsApi.js";
import Reference from "@/components/Reference";

export default {
  components: {
    Reference,
  },
  props: {
    label: {
      type: String,
      default: "Найменування",
    },
    value: {
      type: [Object, Array],
    },
    placeholder: {
      type: String,
      default: "",
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    errorMessages: {
      type: Array,
    },
    multipleSelect: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    totalItems: 0,
    items: [],
  }),
  methods: {
    async getItems({ currentPage, perPage, search }) {
      this.items = [];
      const { result, totalItems } = await clientsApi.getClientReferences(
        currentPage,
        perPage,
        search,
      );
      this.items = [...this.items, ...result];
      this.totalItems = totalItems;
    },
  },
};
</script>
